import React from 'react';

import { Page } from 'src/ui/templates/page';
import { GroupsGrid } from 'src/ui/molecules/groups-grid';
import { CreateGroupButton } from 'src/features/home/ui/create-group-button';
import { fetchOpenGroupsFx, groupFavoriteFx, openGroups$ } from 'src/store/groups-collection.store';

export const OpenGroupsPage = () => {
	return (
		<Page>
			<GroupsGrid
				fetchGroupsFx={fetchOpenGroupsFx}
				groups$={openGroups$}
				onFavorite={(payload) => groupFavoriteFx(payload)}
			/>
			<CreateGroupButton/>
		</Page>
	);
};
